import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { ClickAwayListener } from '@mui/material';
import moment, { Moment } from 'moment';
import React, { Fragment, useRef, useState } from 'react';
import { resetSellerRankFilter, setUpdateSellerRankFilter } from 'v3/data/store/Rank/RankSeller/actions';
import {
  ActionsBox,
  Content,
  DateBox,
  MarginContainer,
  StyledActionButton,
  StyledPaper,
  StyledPopper,
  TitleContainer,
} from 'v3/shared/components/Filters/FilterByPeriod/styles';
import { FilterByPeriodProps } from 'v3/shared/components/Filters/FilterByPeriod/type';
import { DateRangePicker } from 'v3/shared/components/Inputs/DateRangePicker';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { TitleMedium } from 'v3/shared/typography/TitleMedium';
import { theme } from 'v3/styles/global-styles';

export const FilterByPeriod = ({ dateRange, setDateRange, onClear }: FilterByPeriodProps) => {
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState<[Moment | null, Moment | null]>();
  const anchorRef = useRef<HTMLDivElement>(null);
  const minDate = moment().subtract(6, 'months');

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickAway = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    handleClose();
  };

  const handleApply = () => {
    if (range && range[0] !== null && range[1] !== null) {
      const startUtc = moment(range[0]).startOf('day').utc().toISOString();
      const endUtc = moment(range[1]).utc().endOf('day').toISOString();

      setDateRange(range);
      setUpdateSellerRankFilter({
        startDate: startUtc,
        finalDate: endUtc,
      });
    }
    setOpen(false);
  };

  const handleClear = () => {
    const emptyRange: [Moment | null, Moment | null] = [null, null];

    setRange(emptyRange);
    setDateRange(emptyRange || null);
    resetSellerRankFilter();
    onClear?.();
  };

  const handleChangeDatePicker = (value: [string | null, string | null]) => {
    const [startStr, endStr] = value;
    const start = startStr ? moment(startStr) : null;
    const end = endStr ? moment(endStr) : null;
    const newRange: [Moment | null, Moment | null] = [start, end];
    setRange(newRange);
  };

  const hasActiveRange = !!(dateRange[0] && dateRange[1]);

  return (
    <Fragment>
      <Content ref={anchorRef} onClick={handleToggle} className={hasActiveRange ? 'active' : ''}>
        <CalendarMonthOutlinedIcon />
        <BodySmallRegular>Filtrar por período</BodySmallRegular>
      </Content>

      <StyledPopper open={open} anchorEl={anchorRef.current} placement="bottom-start" disablePortal>
        <ClickAwayListener onClickAway={handleClickAway}>
          <MarginContainer>
            <StyledPaper>
              <DateBox>
                <TitleContainer>
                  <TitleMedium>Defina o período</TitleMedium>
                  <BodySmallRegular color={theme.palette.secondary.light}>Filtre por dia ou intervalo</BodySmallRegular>
                </TitleContainer>
                <DateRangePicker value={dateRange} onChangeDatePicker={handleChangeDatePicker} minDate={minDate} />
              </DateBox>

              <ActionsBox>
                <StyledActionButton onClick={handleClear} variant="outlined" color="inherit" fullWidth>
                  Limpar
                </StyledActionButton>
                <StyledActionButton onClick={handleApply} variant="contained" color="error" fullWidth>
                  Aplicar
                </StyledActionButton>
              </ActionsBox>
            </StyledPaper>
          </MarginContainer>
        </ClickAwayListener>
      </StyledPopper>
    </Fragment>
  );
};
